module.exports = __webpack_public_path__ + "img/icon-basket-blue.10df4780.svg";